import { baseViewModelToViewModelConverter } from "./converter";
import { useSiteControllerSettingNeppanFormModelMethods } from "./methods";
import { type SiteControllerSettingNeppanFormModel } from "../../type";

import type { SiteControllerSettingBaseFormModel } from "../../../base/type";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../base/use-case/use-create-model/use-create-model";

type ViewModel = SiteControllerSettingNeppanFormModel["ViewModel"];
export type SiteControllerSettingNeppanFormModelOnSetViewModelType = <K extends keyof ViewModel>(
	values: { key: K; value: ViewModel[K] }[],
) => void;

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export const useCreateSiteControllerSettingNeppanFormModel = ({ viewModel: _viewModel, onSetViewModel }: Props) => {
	const { viewModel } = baseViewModelToViewModelConverter({ viewModel: _viewModel });

	return {
		viewModel,
		...useSiteControllerSettingNeppanFormModelMethods({ viewModel, onSetViewModel }),
	};
};
